__turbopack_context__.v({
  "carousel": "Carousel-module__iQrGzW__carousel",
  "container": "Carousel-module__iQrGzW__container",
  "scrollButton": "Carousel-module__iQrGzW__scrollButton",
  "scrollButtonGrayLeft": "Carousel-module__iQrGzW__scrollButtonGrayLeft",
  "scrollButtonGrayRight": "Carousel-module__iQrGzW__scrollButtonGrayRight",
  "scrollButtonIcon": "Carousel-module__iQrGzW__scrollButtonIcon",
  "scrollButtonWhiteLeft": "Carousel-module__iQrGzW__scrollButtonWhiteLeft",
  "scrollButtonWhiteRight": "Carousel-module__iQrGzW__scrollButtonWhiteRight",
});
